(function () {
    function t() {
        var t = (new Date).getTime(),
            script = document.createElement("script");
        
        script.type = "text/javascript";
        script.async = true;
        script.setAttribute("embed-id", "5d22f0f6-deb0-450d-b0f1-abee5617b621");
        script.src = "https://embed.adabundle.com/embed-scripts/5d22f0f6-deb0-450d-b0f1-abee5617b621";

        var firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    }

    var e = window;
    if (e.attachEvent) {
        e.attachEvent("onload", t);
    } else {
        e.addEventListener("load", t, false);
    }
})();
